import util from '../util'

let base = window.$servicePath;

export default {
    /**
     * 常用主菜单
     */
    listMainMenu() {
        return util.ajax(`${base}/api/app/mainMenu`)
    },
    /**
     * 获取所有应用
     */
    listApplication() {
        return util.ajax(`${base}/api/app/listApplication`)
    },
    groupApplicationByCode(code) {
        return util.ajax(`${base}/api/app/groupApplicationByCode`, code)
    },

    clearComponentData() {
        return util.ajax(`${base}/api/app/clearComponentData`, null)
    },
    getFormFields(formId) {
        return util.ajax(`${base}/api/app/getFormFields`, formId)
    },

    listFormKeys() {
        return util.ajax(`${base}/api/app/listFormKeys`)
    },

    /**
     * 获取脚本组件
     */
    listActionComponent(params) {
        return util.ajax(`${base}/api/app/listActionComponent`, params)
    },

    createActionComponent(params) {
        return util.ajax(`${base}/api/app/createActionComponent`, params)
    },

    createPageComponent(params) {
        return util.ajax(`${base}/api/app/createPageComponent`, params)
    },

    getScriptComponent(id) {
        return util.ajax(`${base}/api/app/getScriptComponent`, id)
    },
    removeComponent(ids) {
        return util.ajax(`${base}/api/app/removeComponent`, ids)
    },
    /**
     * 获取数据库组件
     */
    listDatabaseComponent(params) {
        return util.ajax(`${base}/api/app/listDatabaseComponent`, params)
    },

    createDatabaseComponent(params) {
        return util.ajax(`${base}/api/app/createDatabaseComponent`, params)
    },
    getDatabaseComponent(id) {
        return util.ajax(`${base}/api/app/getDatabaseComponent`, id)
    },
    /**
     * 获取默认流程按钮
     */
    getDefaultButton(params) {
        params.flag = 1
        return util.ajax(`${base}/api/app/listActionComponentByType`, params)
    },

    /**
     * 获取所有流程按钮
     */
    getAllButton(params) {
        //params.flag=0
        return util.ajax(`${base}/api/app/listActionComponentByType`, params)
    },

    /**
     * 新增应用
     */
    createApplication(params) {
        return util.ajax(`${base}/api/app/createApplication`, params)
    },

    /**
     * 修改应用
     * 应用ID
     */
    setApplicationProperties(params, id) {
        return util.ajax(`${base}/api/app/setApplicationProperties`, params, id)
    },

    updateApplicationCode(params) {
        return util.ajax(`${base}/api/app/updateApplicationCode`, params)
    },

    updateApplicationSn(ids) {
        return util.ajax(`${base}/api/app/updateApplicationSn`, ids)
    },
    /**
     * 删除应用
     *  id应用ID
     */
    removeApplication(id) {
        return util.ajax(`${base}/api/app/removeApplication`, id)
    },

    /**
     * 复制应用
     * id应用ID
     */
    copyApplication(id) {
        //return util.ajax(`${base}/api/app/copyApplication`, id)
    },


    /**
     * 创建应用分类
     */
    createApplicationItem(params, appId) {
        return util.ajax(`${base}/api/app/createApplicationItem`, params, appId)
    },


    /**
     * 修改应用分类
     * @param params 其他参数
     * @param id  分类ID
     * @param appId  分类所属应用ID
     */
    setApplicationItemProperties(params, id, appId) {
        return util.ajax(`${base}/api/app/setApplicationItemProperties`, params, id, appId)
    },

    saveViewConfig(params, id, appId) {
        return util.ajax(`${base}/api/app/saveViewConfig`, params, id, appId)
    },



    /**
     * 删除应用分类
     * @param id  分类ID
     * @param appId  分类所属应用ID
     */
    removeApplicationItem(id, appId) {
        return util.ajax(`${base}/api/app/removeApplicationItem`, id, appId)
    },


    /**
     * 获取应用分类
     */
    getApplicationItem(id, appId) {
        return util.ajax(`${base}/api/app/getApplicationItem`, id, appId)
    },

    getApplicationItems(ids, appId) {
        return util.ajax(`${base}/api/app/getApplicationItems`, ids, appId)
    },

    /**
     * 获取视图的配置
     * @param ids
     * @param appId
     * @returns {*}
     */
    getApplicationViewItems(ids, params, appId) {
        return util.ajax(`${base}/api/app/getApplicationViewCompItems`, ids, params, appId)
    },
    getApplicationLink(id, appId) {
        return util.ajax(`${base}/api/app/getApplicationLink`, id, appId)
    },
    /**
    获取导航配置
    */
    getNavigatorRecord(id, appId) {
        return util.ajax(`${base}/api/app/getNavigatorRecord`, id, appId)
    },
    /**
     * 获取所有应用分类
     */
    listApplicationItem(appId) {
        return util.ajax(`${base}/api/app/listApplicationItem`, appId)
    },


    getApplication(appId) {
        return util.ajax(`${base}/api/app/getApplication`, appId)
    },

    /**
     * 获取表单信息
     */
    /*  getApplicationForm(fromId,appId){
        return util.ajax(`${base}/api/app/getApplicationForm`,fromId, appId)
      },*/



    /**
     * 获取应用分类树
     * @param appId
     * @param itemId
     * @returns {*}
     */
    listAppItemTree(appId, ItemId) {
        return util.ajax(`${base}/api/app/listAppItemTree`, appId, ItemId)
    },


    sortApplicationItem(parentId, moduleId, appId, sortIds) {
        return util.ajax(`${base}/api/app/sortApplicationItem`, parentId, moduleId, appId, sortIds)
    },

    /**
     * 获取表单列表
     */
    listApplicationFormKey(appId) {
        return util.ajax(`${base}/api/app/listApplicationFormKey`, appId)
    },

    listApplicationView(appId) {
        return util.ajax(`${base}/api/app/listApplicationView`, appId)
    },

    /**
     * 获取表单的配置
     */
    formConfig(id, appId) {
        return util.ajax(`${base}/api/app/formConfig`, id, appId)
    },




    /*  /!**
       * 获取表单的配置
       *!/
      listConfig(id, appId) {
        return util.ajax(`${base}/api/app/listConfig`, id, appId)
      },*/

    //流程配置设置
    saveFlowConfig(data) {
        return util.ajax(`${base}/api/app/saveFlowConfig`, data)
    },

    getFlowConfig() {
        return util.ajax(`${base}/api/app/getFlowConfig`)
    },

    saveComponentRepositoryConfig(data) {
        return util.ajax(`${base}/api/app/saveComponentRepositoryConfig`, data)
    },

    getComponentRepositoryConfig() {
        return util.ajax(`${base}/api/app/getComponentRepositoryConfig`)
    },

    listApplicationItemTree(...args) {
        return util.ajax(`${base}/api/app/listApplicationItemTree`, ...args)
    },

    updateModuleName(...args) {
        return util.ajax(`${base}/api/app/updateModuleName`, ...args)
    },
    updateApplicationEntries(...args) {
        return util.ajax(`${base}/api/app/updateApplicationEntries`, ...args)
    },

    saveModuleData(...args) {
        return util.ajax(`${base}/api/app/saveModuleData`, ...args)
    },

    getModuleDataConfig(...args) {
        return util.ajax(`${base}/api/app/getModuleDataConfig`, ...args)
    },


    saveModuleFlow(...args) {
        return util.ajax(`${base}/api/app/saveModuleSet`, ...args)
    },

    getModuleFlowConfig(...args) {
        return util.ajax(`${base}/api/app/getModuleFlowConfig`, ...args)
    },


    listModuleForm(...args) {
        return util.ajax(`${base}/api/app/listModuleForm`, ...args)
    },

    changeModuleForm(...args) {
        return util.ajax(`${base}/api/app/changeModuleForm`, ...args)
    },

    changeModuleRelateForm(...args) {
        return util.ajax(`${base}/api/app/changeModuleRelateForm`, ...args)
    },

    saveModuleSet(...args) {
        return util.ajax(`${base}/api/app/saveModuleSet`, ...args)
    },
    saveFieldMapping(...args) {
        return util.ajax(`${base}/api/app/saveFieldMapping`, ...args)
    },
    copeForm(...args) {
        return util.ajax(`${base}/api/app/copeForm`, ...args)
    },
    copyModule(...args) {
        return util.ajax(`${base}/api/app/copyModule`, ...args)
    },
    copyModuleFlow(...args) {
        return util.ajax(`${base}/api/app/copyModuleFlow`, ...args)
    },
    relateFlow(...args) {
        return util.ajax(`${base}/api/app/relateFlow`, ...args)
    },
    delRelateFlow(...args) {
        return util.ajax(`${base}/api/app/delRelateFlow`, ...args)
    },
    getModuleSetConfig(...args) {
        return util.ajax(`${base}/api/app/getModuleSetConfig`, ...args)
    },

    /**
     * 保存模块中的表单
     * @param args
     * @returns {*}
     */
    saveModuleForm(...args) {
        return util.ajax(`${base}/api/app/saveModuleForm`, ...args)
    },

    createModuleForm(...args) {
        return util.ajax(`${base}/api/app/createFormDefinition`, ...args)
    },

    publishDefinition(...args) {
        return util.ajax(`${base}/api/app/publishFormDefinition`, ...args)
    },

    removeDefinition(...args) {
        return util.ajax(`${base}/api/app/removeFormDefinition`, ...args)
    },
    recoverDefinition(...args) {
        return util.ajax(`${base}/api/app/recoverFormDefinition`, ...args)
    },

    deleteDefinition(...args) {
        return util.ajax(`${base}/api/app/deleteFormDefinition`, ...args)
    },

    saveModuleMobile(...args) {
        return util.ajax(`${base}/api/app/saveModuleMobile`, ...args)
    },

    listExclusiveMarkDeletedDefinition(...args) {
        return util.ajax(`${base}/api/app/listExclusiveMarkDeletedDefinition`, ...args)
    },

    listMarkDeletedDefinition(...args) {
        return util.ajax(`${base}/api/app/listMarkDeletedDefinition`, ...args)
    },

    listFormVersionByModuleId(...args) {
        return util.ajax(`${base}/api/app/listFormVersionByModuleId`, ...args)
    },

    /**
     * 获取模块中表单配置
     */
    getModuleFormConfig(...args) {
        return util.ajax(`${base}/api/app/getModuleFormConfig`, ...args)
    },

    applicationLinkTree(...args) {
        return util.ajax(`${base}/api/app/applicationLinkTree`, ...args)
    },

    listApplicationItemsByCode(...args) {
        return util.ajax(`${base}/api/app/listApplicationItemsByCode`, ...args)
    },
    getAppModuleItems(...args) {
        return util.ajax(`${base}/api/app/getAppModuleItems`, ...args)
    },

    saveSystemParameter(...args) {
        return util.ajax(`${base}/api/app/saveSystemParameter`, ...args)
    },

    getSystemParameter(...args) {
        return util.ajax(`${base}/api/app/getSystemParameter`, ...args)
    },

    listApplicationItemsByCategory(...args) {
        return util.ajax(`${base}/api/app/listApplicationItemsByCategory`, ...args)
    },

    listSystemService(params) {
        return util.ajax(`${base}/api/app/listSystemService`, params)
    },
    getSystemService(id) {
        return util.ajax(`${base}/api/app/getSystemService`, id)
    },
    saveSystemService(params) {
        return util.ajax(`${base}/api/app/saveSystemService`, params)
    },
    removeSystemService(ids) {
        return util.ajax(`${base}/api/app/removeSystemService`, ids)
    },

    exportApplication(ids) {
        let params = {};
        let json = PF.encode({
            ids: ids,
            fileName: `导出应用(${ids.length})`,
        });
        return util.downloadAttachment(`${base}/api/app/exportApplication`, params, undefined, json, true);
    },
    exportApplicationComp(ids) {
        let params = {};
        let json = PF.encode({
            ids: ids,
            fileName: `导出组件(${ids.length})`,
            excludeCategories: ['flow_def', 'module_flow', 'dict', '数据模型'],
            noProgramFiles: true
        });
        return util.downloadAttachment(`${base}/api/app/exportApplication`, params, undefined, json, true);
    },
    exportComponentByIds(ids, type) {
        let params = {};
        let json = PF.encode({ ids: ids, type: type });
        return util.downloadAttachment(`${base}/api/app/exportComponentByIds`, params, undefined, json, true);
    },

    exportComponentByCategoryIds(ids, moduleName) {
        let params = {};
        let json = PF.encode({ ids: ids, fileName: moduleName });
        return util.downloadAttachment(`${base}/api/app/exportComponentByCategoryIds`, params, undefined, json, true);
    },

    //拷贝视图
    copyView(...args) {
        return util.ajax(`${base}/api/app/copyView`, ...args);
    },
    listModuleFormOperAuthTree(params) {
        return util.ajax(`${base}/api/app/listModuleFormOperAuthTree`, params);
    },
    listComponentsByTypeAndAppId(params) {
        return util.ajax(`${base}/api/app/listComponentsByTypeAndAppId`, params);
    },
    // 全部获取
    listComponentsByAppId(params) {
        return util.ajax(`${base}/api/app/listComponentsByAppId`, params);
    },
    listComponentType(params) {
        return util.ajax(`${base}/api/sys/listComponentType`, params);
    },
    listComponent(params) {
        return util.ajax(`${base}/api/sys/listComponent`, params);
    },
    saveComponent(params) {
        return util.ajax(`${base}/api/app/saveComponent`, params);
    },
    saveEsModelComponent(params) {
        return util.ajax(`${base}/api/app/saveEsModelComponent`, params);
    },
    importEsData(params) {
        return util.ajax(`${base}/api/app/importEsData`, params);
    },
    refreshComponentCache() {
        return util.ajax(`${base}/api/sys/refreshComponentCache`);
    },
    //导航菜单
    getNavigatorTreeNode(appId, nodeId) {
        return util.ajax(`${base}/api/app/getNavigatorTreeNode`, appId, nodeId);
    },
    getNavigatorTree(params) {
        return util.ajax(`${base}/api/app/getNavigatorTree`, params);
    },
    getAuthNavigatorTree(params) {
        return util.ajax(`${base}/api/app/getAuthNavigatorTree`, params);
    },
    saveNavigatorTree(appId, data) {
        return util.ajax(`${base}/api/app/saveNavigatorTree`, appId, data);
    },
    copyNavigatorTree(appId, id) {
        return util.ajax(`${base}/api/app/copyNavigatorTree`, appId, id);
    },
    removeNavigatorTree(appId, id) {
        return util.ajax(`${base}/api/app/removeNavigatorTree`, appId, id);
    },
    dragNavigatorTreeNode(params) {
        return util.ajax(`${base}/api/app/dragNavigatorTreeNode`, params);
    },
    //复制动作脚本
    copyActionComponent(...args) {
        return util.ajax(`${base}/api/app/copyActionComponent`, ...args);
    },
    //拷贝组件
    copyComp(...args) {
        return util.ajax(`${base}/api/app/copyComponent`, ...args);
    },
    getVersionComponent(id) {
        return util.ajax(`${base}/api/app/getVersionComponent`, id)
    },
    listComponentRevision(params) {
        return util.ajax(`${base}/api/sys/listComponentRevision`, params)
    },
    getComponentRevisionRawData(id, repositoryId) {
        return util.ajax(`${base}/api/sys/getComponentRevisionRawData`, id, repositoryId)
    },
    revertComponent(ids) {
        return util.ajax(`${base}/api/sys/revertComponent`, ids)
    }

}


// WEBPACK FOOTER //
// ./src/common/api/app.js